import {colorMap} from '@modules/constants-enumerate';
import {repeat} from 'lit-html/directives/repeat';
import '@routes/dashboard/modules/user-initials-button';
import {until} from 'lit-html/directives/until';

export default (ctx, html) => {
  if (ctx.students.length === 0) {
    return;
  }
  return html`
    <div class="pb-4 ${ctx.collapsesByStatus?.[ctx.status] ? 'collapsed' : ''}">
      <div @click="${() => ctx.toggleCollapse(ctx.status)}" class="d-flex flex-row justify-content-between align-items-center cursor-pointer mb-3 mt-4">
        <div>
          <div class="key-icon mr-1" style="background-color: ${colorMap[ctx.status]};"></div>
          ${until(ctx.header)}
        </div>
        <span class="ai ai-Chevron_Black chevron text-blue"></span>
      </div>
      <div class="student-activity-section">
        ${repeat(ctx.students, (student) => student, (student) => html`
          <div class="d-inline-block text-center student-wrapper p-2 student-initial-wrapper">
            <user-initials-button
              id="${student.id}"
              @click="${(e) => ctx.openStudentDashboard({detail: {student}}, e)}"
              .color="${colorMap[ctx.status]}"
              .content="${student.initials}"
              .textColor="${ctx.bubbleTextColor}">
            </user-initials-button>
            <div class="ellipsis text-nowrap">${student.abbreviated}</div>
          </div>`)}
      </div>
    </div>
  `;
};
